export class AtendimentoEspecialistaSimples {
  ativo: boolean;
  especialista: number;
  pOrigem: string;
  pDestino: string;
  idioma: string;
  boleto: boolean;
  cdTransacao?: string;
}
